module.exports = __webpack_public_path__ + "static/media/pink_box_24dp.237028c2.svg";